import { AppInjector } from './../../app-injector';
import { ApiUrl } from './../api-url.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ServiceProvider } from '../service.provider';
import { catchError, tap, map } from 'rxjs/operators';
import { Observable } from 'rxjs/Observable';
import Track from '../../models/Track';
import Product from '../../models/Product';
import * as _ from 'lodash';
import Inventory from '../../models/Inventory';
import ProductTrack from '../../models/ProductTrack';

@Injectable()
export class TrackService extends ServiceProvider {
  protected url = '/api/v1/tracks';

  constructor() {
    super(AppInjector.get(HttpClient), AppInjector.get(ApiUrl), 'Track');
  }

  check(track_id, sku): Observable<any> {
    return this.http.get(this.apiUrl.getApiUrl(this.url) + `/${track_id}/check/${sku}`).pipe(
      tap(result => {
        // console.log(result);
      }),
      map(result => new Inventory((result as any).data)),
      catchError(error => {
        throw error;
      })
    );
  }

  getLastTrackOfProducts(params = {}): Observable<any> {
    return this.http.get(this.apiUrl.getApiUrl(this.url) + `/last-track-of-products`, { params }).pipe(
      map(result => _.map((result as any).data, item => new ProductTrack(item))),
      catchError(error => {
        throw error;
      })
    );
  }

  getTrackedProducts(locationId): Observable<any> {
    return this.http.get(this.apiUrl.getApiUrl(this.url) + `/${locationId}/products`).pipe(
      map(result => _.map((result as any).data, item => new Product(item))),
      catchError(error => {
        throw error;
      })
    );
  }

  getLastScan(locationId): Observable<any> {
    return this.http.get(this.apiUrl.getApiUrl(this.url) + `/${locationId}/latest`).pipe(
      map(result => new Track((result as any).data)),
      catchError(error => {
        throw error;
      })
    );
  }

  getAllLatestScan(params = {}): Observable<any> {
    return this.http.get(this.apiUrl.getApiUrl(this.url) + '/latest', { params: params }).pipe(
      map(results => _.map((results as any).data, item => new Track(item))),
      catchError(error => {
        throw error;
      })
    );
  }

  complete(track_id): Observable<any> {
    return this.http.put(this.apiUrl.getApiUrl(this.url) + `/${track_id}/complete`, null).pipe(
      map(results => _.map((results as any).data, item => new Product(item))),
      catchError(error => {
        throw error;
      })
    );
  }
  /**
   * Remove scanned item from track
   *
   * @param track_id
   * @param product_sku
   *
   * @return Observable
   */
  removeScannedItem(track_id, product_sku): Observable<any> {
    return this.http.delete(this.apiUrl.getApiUrl(this.url) + `/${track_id}/products/${product_sku}`).pipe(
      catchError(error => {
        throw error;
      })
    );
  }

  /**
   * Remove scanned item from track
   *
   * @param track_id Number
   *
   * @return Observable
   */
  resetCurrentScan(track_id: Number): Observable<any> {
    return this.http.put(this.apiUrl.getApiUrl(this.url) + `/${track_id}/reset`, {}).pipe(
      catchError(error => {
        throw error;
      })
    );
  }
}
